import styled from "@emotion/styled";
import * as spacing from "src/styles/constants/spacing";
import { Status as Badge } from "src/styles/badge";
import * as colors from "src/styles/constants/colors";

export const LinkIconWrapper = styled.div`
  > span:first-of-type {
    color: ${colors.active};
  }
  :hover {
    > span > svg {
      visibility: visible !important;
    }
  }
`;

export const New = styled(Badge)`
  display: inline-block;
  font-weight: normal;
  margin-right: ${spacing.space_m};
  margin-left: ${spacing.space_m};
  cursor: pointer;
  text-transform: uppercase;
  line-height: 1.6 !important;
  padding: 0 ${spacing.space_default} 0 ${spacing.space_default};
`;
